class GoogleCalendarOauthCtrl {
  constructor(code, $window) {
    'ngInject';

    $window.opener.resolveGoogleCalendarPromise?.(code);
    $window.close();
  }
}

export default GoogleCalendarOauthCtrl;
